import React from "react";
import { Grid, Icon, Label, Button, Popup } from "semantic-ui-react";
import moment from "moment";
import { getFullNameAndMatricule } from "utils/displayName";
import { dateDiff, getWaitingTime } from "utils/dateUtils";

const styles = {
	rowContainer: {
		backgroundColor: "#fff",
		padding: 10,
		boxShadow: "0px 9px 35px -23px rgba(148,148,148,1)",
		borderRadius: "4px",
		width: "100%",
		minHeight: 100,
		margin: "3px 13px",
	},

	column: {
		color: "#00917d",
		fontWeight: 600,
		fontSize: "0.9em",
		width: "40%",
	},

	columnButton: {
		color: "#00917d",
		fontWeight: 600,
		fontSize: "0.9em",
		width: "8%",
	},

	commentsList: {
		maxHeight: "120px",
		overflow: "auto",
		padding: "5px",
	},

	commentContainer: {
		margin: "3px 0",
		maxHeigth: "150px",
		border: "1px solid whitesmoke",
	},
	commentHeader: {
		display: "flex",
		justifyContent: "flex-end",
	},

	time: {
		color: "#d1b8b8",
		fontSize: "0.8em",
		textAlign: "right",
	},
	comment: {
		color: "black",
		width: "100%",
		backgroundColor: "white",
		borderRadius: "7px",
		padding: "0 7px",
	},
	who: {
		color: "rgb(0, 145, 125)",
		borderRadius: "3px",
		padding: "0px 5px",
		fontSize: "0.8em",
		textAlign: "right",
	},
};

const getRibbonColor = (folderHelp) => {
	switch (folderHelp.status) {
		case "INIT":
			return "black";
		case "NEW":
			return "yellow";
		case "SUPPORT":
			return "orange";
		case "REASSIGNED":
			return "black";
		case "DONE":
			return "brown";
		case "ASSIGNED":
			return "orange";
		case "PENDING":
			return "red";
		case "CANCELED":
			return "grey";
		case "CANCELEDBYSEC":
			return "grey";
		default:
			break;
	}
};

const getRibbonText = (folderHelp) => {
	switch (folderHelp.status) {
		case "INIT":
			return "En attente du document";
		case "NEW":
			return "A faire";
		case "SUPPORT":
			return `En cours de traitement par ${folderHelp.assigned_to ? folderHelp.assigned_to.first_name : ""} ${
				folderHelp.assigned_to ? folderHelp.assigned_to.last_name : ""
			}`;
		case "REASSIGNED":
			if (folderHelp.folder?.is_temp) {
				return `Traité et en attente de la venue du patient dans un centre`;
			}
			return `Traité et en attente de prélèvement ${folderHelp.assigned_to ? folderHelp.assigned_to.first_name : ""} ${
				folderHelp.assigned_to ? folderHelp.assigned_to.last_name : ""
			}`;

		case "DONE":
			return "Terminé";
		case "ASSIGNED":
			return `Assigné à ${folderHelp.assigned_to ? folderHelp.assigned_to.first_name : ""} ${
				folderHelp.assigned_to ? folderHelp.assigned_to.last_name : ""
			}`;
		case "PENDING":
			return "En attente d'un.e senior";
		case "CANCELED":
			return "Annulé par la préleveuse";
		case "CANCELEDBYSEC":
			return "Annulé par la secrétaire";
		default:
			break;
	}
};

const PreregisterListItem = ({ preregister, item, total, goToFolderManager, canSee, postAssignToMe, support }) => {
	const folderHelp = { ...preregister.folder?.folderHelp, folder: { ...preregister.folder } };
	const hasFolder = !!preregister.folder;

	const clickToEnter = async (e) => {
		if (e !== undefined) e.preventDefault();
		if (folderHelp.status === "NEW" || folderHelp.status === "PENDING") await postAssignToMe(folderHelp.id);
		if (folderHelp.status === "NEW" || folderHelp.status === "ASSIGNED" || folderHelp.status === "PENDING" || folderHelp.status === "REASSIGNED")
			await support(folderHelp.folder.id);
		goToFolderManager(folderHelp.folder.id);
	};

	const getWaitingTimeFolderHelp = (folderHelp) => {
		return (
			<span style={{ padding: "0 4px" }}>
				{folderHelp.status === "DONE" ||
				folderHelp.status === "REASSIGNED" ||
				folderHelp.status === "CANCELED" ||
				folderHelp.status === "CANCELEDBYSEC"
					? getWaitingTime(folderHelp.created_at, folderHelp.updated_at)
					: getWaitingTime(folderHelp.created_at)}
			</span>
		);
	};

	const getSupportedNames = (folderHelp) => {
		if (folderHelp.historics?.some((h) => h.status_to === "SUPPORT")) {
			return [
				...new Set(folderHelp.historics?.filter((h) => h.status_to === "SUPPORT").map((h) => h.assignedTo.first_name + " " + h.assignedTo.last_name)),
			].join(", ");
		} else return null;
	};
	return (
		<Grid.Row style={{ ...styles.rowContainer }} key={`help-folder-${folderHelp?.id}`}>
			<Grid.Column mobile={7} tablet={7} computer={5} style={{ ...styles.column }}>
				{preregister.waitingFlag && (
					<div>
						<Label as="span" color="orange" ribbon>
							Mis en attente par une secrétaire
						</Label>
					</div>
				)}
				{folderHelp.fromPreregister && (
					<div>
						<Label as="span" color="violet" ribbon>
							Pré-inscription reçue le {moment(folderHelp.created_at).format("DD/MM/YYYY[ à ]HH:mm")}
						</Label>
					</div>
				)}
				<div>
					<Label as="span" color={getRibbonColor(folderHelp)} ribbon>
						{getRibbonText(folderHelp)}
					</Label>
				</div>
				{getSupportedNames(folderHelp) && (
					<div>
						<Label as="span" style={{ backgroundColor: "darkslategray", color: "white" }} ribbon>
							Traité par : {getSupportedNames(folderHelp)}
						</Label>
					</div>
				)}

				<div>
					<Label as="span" style={{ backgroundColor: "#00917d", color: "white" }} ribbon>
						Temps d'attente : {getWaitingTimeFolderHelp(folderHelp)}
					</Label>
				</div>
				<div>
					Dossier {folderHelp.folder?.code}{" "}
					{!folderHelp.fromPreregister && (
						<Popup
							content={
								folderHelp.comments.filter((c) => c.comment && c.comment.endsWith("Document associé automatiquement")).length > 0
									? "Document associé automatiquement"
									: "Le document n'a pas pu être associé automatiquement"
							}
							trigger={
								<Icon
									name="file"
									color={
										folderHelp.comments.filter((c) => c.comment && c.comment.endsWith("Document associé automatiquement")).length > 0
											? "green"
											: "grey"
									}
								/>
							}
						/>
					)}
				</div>

				<div>
					{" "}
					{preregister.birth_name &&
						getFullNameAndMatricule({
							cns: preregister.matricule,
							birth_name: preregister.birth_name,
							first_name: preregister.first_name,
							married_name: preregister.last_name,
						})}{" "}
					{!preregister.birth_name &&
						getFullNameAndMatricule({
							cns: preregister.folder?.patient?.cns,
							birth_name: preregister.folder?.patient?.birth_name,
							first_name: preregister.folder?.patient?.first_name,
							married_name: preregister.folder?.patient?.last_name,
						})}{" "}
				</div>
				<div>
					{preregister.email} - {preregister.mobile_phone}
				</div>
				<div>Patient MyLab : {preregister.mylab_id ? "Oui" : "Non"}</div>
				<div>En centre : {preregister.is_at_center ? "Oui" : "Non"}</div>
				<div style={{ fontSize: "0.9em" }}>QR Code : {preregister.qr_code}</div>
			</Grid.Column>
			<Grid.Column mobile={5} tablet={6} computer={8} style={{ ...styles.column }}>
				{folderHelp.comments && folderHelp.comments.filter((c) => c.manual).length > 0 && (
					<div>
						<div>Commentaires : </div>
						<div style={{ ...styles.commentsList }}>
							{folderHelp.comments
								.filter((c) => c.manual)
								.slice()
								.sort((a, b) => moment(b.created_at).diff(moment(a.created_at)))
								.map((c) => (
									<div style={{ ...styles.commentContainer }} key={`commenthf-${c.id}`}>
										{c.cancellation && c.cancelReason && (
											<Label ribbon>
												<span style={{ fontSize: "0.9rem" }}>Annulation de la demande de télésecrétariat : </span>
												{c.cancelReason.label}
											</Label>
										)}
										<div style={{ ...styles.commentHeader }}>
											{c.created_by && (
												<span style={{ ...styles.who }}>
													{c.created_by.first_name} {c.created_by.last_name}
												</span>
											)}
											<span style={{ ...styles.time }}>
												{moment(c.created_at).format(`${process.env.REACT_APP_DATE_DISPLAY_FORMAT}, ${process.env.REACT_APP_TIME_DISPLAY_FORMAT}`)}
											</span>
										</div>
										<div style={styles.comment}>
											<div style={{ ...styles.commentText }}> {c.comment}</div>
										</div>
									</div>
								))}
						</div>
					</div>
				)}
			</Grid.Column>

			<Grid.Column mobile={4} tablet={3} computer={3} style={{ ...styles.columnButton }}>
				<div style={{ display: "flex", flexDirection: "column", justifyContent: "space-between", height: "150px" }}>
					{((folderHelp.status === "PENDING" && canSee) || (folderHelp.status === "ASSIGNED" && canSee)) && (
						<Button color="orange" onClick={clickToEnter}>
							Prendre en charge
						</Button>
					)}
					{((folderHelp.status === "SUPPORT" && canSee) || folderHelp.status === "NEW" || folderHelp.status === "REASSIGNED") && (
						<Button color="orange" onClick={clickToEnter}>
							Ouvrir
						</Button>
					)}
				</div>
			</Grid.Column>
		</Grid.Row>
	);
};

export default PreregisterListItem;
